import React, {ReactNode} from 'react';

import {useQueryParams} from 'shared/utils/query-params/use-query-params.hook';

import './query-param-link.less';

export interface IQueryParamLinkProps {
    params: { name: string; value: string }[];
    children: ReactNode;
}

export const QueryParamLink = ({params, children}: IQueryParamLinkProps) => {
    const {updateQueryParams} = useQueryParams();
    const handleLinkClick = () => {
        updateQueryParams(params);
    };

    return (
        <div
            className="query-param-link"
            onClick={() => handleLinkClick()}
        >
            {children}
        </div>
    );
};
